import { mapFlatpageDto } from '@features/flatpages/api/flatpagesMapper'
import type { Flatpage } from '@features/flatpages/types'
import type { FlatpageDto } from '@shared/api/flatpages.dto'
import { useNuxtApi } from '@shared/nuxt/useNuxtApi'

export const flatpagesApi = {
  getPage(params: { city: string; path: string }) {
    return useNuxtApi<FlatpageDto, Flatpage>('/api/flatpages', {
      query: {
        city: params.city,
        path: params.path,
      },
      transform: mapFlatpageDto,
    })
  },
}
